export default class FetchError extends Error {
  constructor (json, response, url, shouldUseServerMessage = false) {
    super('Fetch failed')
    this.json = json
    this.response = response
    this.url = url
    this.shouldUseServerMessage = shouldUseServerMessage
  }
}
